import { render, staticRenderFns } from "./smartAgriculture.vue?vue&type=template&id=8bcd7fca"
import script from "./smartAgriculture.vue?vue&type=script&lang=js"
export * from "./smartAgriculture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports